import p1 from "./assets/product/1.png";
import p2 from "./assets/product/2.png";
import p3 from "./assets/product/3.png";
import p4 from "./assets/product/4.png";
import p5 from "./assets/product/5.png";

export const PRODUCTS = [
  {
    id: 1,
    name: "Chicken Fried Rice",
    description: "Wok-tossed with egg & fresh veggies",
    price: "₹120",
    image: p1,
  },
  {
    id: 2,
    name: "Chinese Pasta",
    description: "Spiced noodles with crispy chicken bites",
    price: "₹150",
    image: p2,
  },
  {
    id: 3,
    name: "Chicken Pizza",
    description: "Golden crust with FFC special sauce",
    price: "₹260",
    image: p3,
  },
  {
    id: 4,
    name: "Chicken Noodles",
    description: "Tangy sauced noodles, tossed to perfection",
    price: "₹130",
    image: p4,
  },
  {
    id: 5,
    name: "Grilled Chicken",
    description: "Marinated & flame-grilled, served hot",
    price: "₹200",
    image: p5,
  },
];
